<template>
  <div id="container">
    <the-header id="header" />
    <div
      id="body"
      :style="'padding-bottom: ' + footerHeight"
    >
      <router-view v-slot="slotProps">
        <transition
          name="route"
          mode="out-in"
        >
          <component :is="slotProps.Component" />
        </transition>
      </router-view>
    </div>
    <the-footer />
  </div>
</template>

<script>
import TheHeader from "./components/layout/TheHeader.vue";
import TheFooter from "./components/layout/TheFooter.vue";

export default {
  components: {
    TheHeader,
    TheFooter,
  },
  computed: {
    didAutoLogout() {
	return this.$store.getters.didAutoLogout;
    },
    userId() {
      return this.$store.getters.userId;
    },
    seasonId() {
      return this.$store.getters["seasons/currentSeason"].seasonId;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    debug() {
      return this.$store.getters.debugMode;
    },
    footerHeight() {
      var height = 3; // this starts at 3 because there is a 2rem padding after each base-card

      // height += ( this.updateExists ) ? 1.5 : 0;
      return height + "rem"
    },
  },
  watch: {
    didAutoLogout(curValue, oldValue) {
      if (curValue && curValue !== oldValue) {
        this.$router.replace("/");
      }
    },
  },
  async created() {
    console.group("App.vue created");

    // console.info("dispatching loadData");
    // await this.$store.dispatch("loadData");

    // this.updateExists = true;

    console.info("finished dispatching in created");
    console.groupEnd();
  },
  // data() {
  //   return {
  //     footerHeight: 2,
  //   }
  // },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px; /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: "liga";
}

* {
  box-sizing: border-box;
  /* --mobile-breakpoint: 64rem; */
}

html {
  font-family: "Roboto", sans-serif;
}

/* body {
  margin: 0;
  padding: 0;
  height: 100%;
}
 */
#container {
  min-height: 100%;
  position: relative;
}

#body {
  padding: 10px;
  /* padding-bottom: 5rem; */
  padding-top: 3rem;
}

.route-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.route-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

.route-enter-to,
.route-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
